import { DatePipe } from '@angular/common'
import {
  ChangeDetectorRef,
  Component,
  HostListener,
  Input,
  OnInit,
} from '@angular/core'

import { Portfolio } from '../../portfolio.model'

@Component({
  selector: 'vmf-top-ten-holdings',
  templateUrl: './top-ten-holdings.component.html',
  styleUrls: ['./top-ten-holdings.component.scss'],
})
export class TopTenHoldingsComponent implements OnInit {
  @Input() portfolioModel: Portfolio
  constructor(private readonly cdRef: ChangeDetectorRef) {
    this.datePipe = new DatePipe('en-US')
  }
  scrollBarPosition = 0
  showRightButton = true
  public innerWidth: any
  tableContainer: HTMLElement
  public datePipe: DatePipe
  public profileData: any
  public displayMonthEndTenLargestHoldingsSection: boolean
  // eslint-disable-next-line complexity, max-statements
  ngOnInit(): void {
    this.profileData = this.portfolioModel?.profileData
    this.displayMonthEndTenLargestHoldingsSection =
      ((this.profileData.isInternational ||
        this.profileData.isGlobal ||
        this.profileData.isStock ||
        this.profileData.isBalanced) &&
        !this.profileData.isFundOfFunds) ||
      (this.profileData.isFundOfFunds && this.profileData.isExternalFund)
    this.innerWidth = window.innerWidth
    //this.calltableScrollEvent()
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.innerWidth = window.innerWidth
  }
  ngAfterViewChecked() {
    this.cdRef.detectChanges()
  }
  // calltableScrollEvent() {
  //   setTimeout(() => {
  //     this.tableContainer = document.querySelector('.horizontal-scroll-table')
  //     this.tableContainer.addEventListener('scroll', () => {
  //       this.scrollTableHandler()
  //     })
  //     // eslint-disable-next-line @typescript-eslint/no-magic-numbers
  //   }, 300)
  // }

  // scrollTableHandler() {
  //   this.showRightButton =
  //     this.tableContainer.offsetWidth + this.tableContainer.scrollLeft >
  //     // eslint-disable-next-line @typescript-eslint/no-magic-numbers
  //     this.tableContainer.scrollWidth - 1
  //       ? false
  //       : true
  //   this.scrollBarPosition = this.tableContainer.scrollLeft
  // }

  // moveRight() {
  //   // eslint-disable-next-line @typescript-eslint/no-magic-numbers
  //   this.tableContainer.scrollLeft += 150
  // }

  // moveLeft() {
  //   // eslint-disable-next-line @typescript-eslint/no-magic-numbers
  //   this.tableContainer.scrollLeft -= 150
  // }
}
